import { makeStyles } from '@material-ui/core'

const styles = makeStyles(() => ({
  typographySubtitle: {
    textAlign: 'center',
    fontWeight: 400,
  },
}))

export default styles
